import styled from '@emotion/styled';
import React from 'react';
import { color } from 'src/shared/styles/variables';

interface Props {
    percentage: number;
}

const Background = styled('div')({
    position: 'relative',
    margin: 24,
    minHeight: 8,
    backgroundColor: color.whiteLilac,
    borderRadius: 18,
    width: 'calc(100% - 48px)',
});

const Foreground = styled('div')<Props>(({ percentage }) => {
    return {
        width: `${percentage}%`,
        position: 'absolute',
        transition: '0.3s width',
        height: 8,
        backgroundColor: color.royalBlue,
        borderRadius: 18,
    };
});

export const ProgressBar: React.FC<Props> = props => {
    return (
        <Background>
            <Foreground percentage={props.percentage} />
        </Background>
    );
};
